import { render, staticRenderFns } from "./ArmsBaseProjectCatalog.vue?vue&type=template&id=58c9397c&scoped=true&"
import script from "./ArmsBaseProjectCatalog.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseProjectCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9397c",
  null
  
)

export default component.exports